<template>
  <div class="card directory-list-card directory-cost-code-card">
        <div class="card-header directory-list-card__header">
            <div class="directory-list-card__title">
                <h4>{{ $t('Cost Codes') }}</h4>
            </div>
            <div class="directory-list-card__actions directory-cost-code-actions">
                <button class="btn btn-primary directory-add-btn" data-bs-toggle="modal" data-bs-target="#CreateCostCodeModal" @click="OpenCreateModal"><i class="fa-solid fa-plus"></i> {{ $t('Add Cost Code') }}</button>
                <button class="btn btn-primary directory-add-btn directory-template-btn" :disabled="isGenerating" @click="GenerateCostCodeTemplate">
                    <i class="fa-solid fa-wand-magic-sparkles"></i>
                    {{ isGenerating ? $t('Syncing...') : $t('Sync System Template') }}
                </button>
            </div>
        </div>
        <div class="card-body directory-list-card__body">
            <div class="directory-list-toolbar directory-cost-code-toolbar">
                <div class="directory-cost-code-search">
                    <Select2
                    :filterQuery="searchCostCodeList"
                    indexValue="_id"
                    labelName="costName"
                    :placeHolder="$t('Type to search for cost code')"
                    v-model:optionValue="searchVal"
                    ref="searchCostCode"
                    :onOptionClick="SearchAppend"
                    ></Select2>
                </div>
                <div class="directory-cost-code-filter">
                    <select class="form-select" v-model="costCodeStatus" @change="()=>{ GetItemsCostCode('',0)}">
                        <option value="1">{{ $t('In Use') }}</option>
                        <option value="2">{{ $t('All (Including Inactive)') }}</option>
                    </select>
                </div>
            </div>
            <div class="directory-cost-code-grid">
                <div class="directory-cost-code-column" v-for="(label,key) in costCodeLabels" :key="label">
                    <CostCodeColumn
                    :onRemoveClicked="DeleteCostCodeRun" 
                    :onRestoreClicked="RestoreCostCodeRun" 
                    :data="dataCostCode[key]" 
                    :clickItem="GetItemsCostCode" 
                    :index="key" 
                    :labels="costCodeLabels" 
                    :emptyText="emptyCostCodeText(key)"
                    :clickUpdate="OpenUpdateModal" 
                    :highlighted="highlighted"
                    :dataSelected="dataSelected"
                    :UpdateIndexSelected="UpdateIndexSelected"
                    />
                </div>
            </div>
        </div>
    </div>
    <Modal idModal="CreateCostCodeModal" :headerTitle="$t('Create Cost Code')">
        <div class="user-modal-form">
        <div class="form-group">
            <label>{{ $t('Parent Cost Code') }}</label>
            <Select2
            :filterQuery="searchCostCode"
            indexValue="_id"
            labelName="costName"
            subLabel="categoryRemark"
            :placeHolder="$t('Type to search for a parent')"
            v-model:optionValue="newCostCode.parent"
            :onOptionClick="AppendCostCodeData"
            :onClear="ResetSelectParent"
            ref="selectCostCode"
            ></Select2>
        </div>
        <div class="form-group" v-if="!newCostCode.parent || newCostCode.parentCount ==0">
            <label :class="{ 'required-style': !String(newCostCode.costCode || '').trim() }">{{ $t('Cost Code') }}</label>
            <input type="text" class="form-control text-capitalize" v-model="newCostCode.costCode" :placeholder="$t('Cost Code Name')"/>
            <small class="text-warning" v-if="!newCostCode.costCode && isClicked">{{ $t('Required') }}</small>
        </div>
        <div class="form-group" >
            <label :class="{ 'required-style': !String(newCostCode.name || '').trim() }">{{ $t('Description') }}</label>
            <textarea class="form-control text-capitalize" v-model="newCostCode.name" :placeholder="$t('Cost Code Description')"></textarea>
            <small class="text-warning" v-if="!newCostCode.name && isClicked">{{ $t('Required') }}</small>
        </div>
        <div class="form-group" v-if="!newCostCode.hideType">
            <label :class="{ 'required-style': !newCostCode.type }">{{ $t('Type') }}</label>
            <select class="form-select" v-model="newCostCode.type">
                <option :value="key + 1" v-for="(item,key) in CostCodeTypeNames" :key="key">{{ $t(item) }}</option>
            </select>
            <small class="text-warning" v-if="!newCostCode.type&&isClicked">{{ $t('Required') }}</small>
        </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeAddModal" class="btn user-modal-btn user-modal-btn--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <button class="btn user-modal-btn user-modal-btn--submit" ref="createBtn" @click="CreateCostCodeRun">{{ $t('Create') }}</button>
        </template>
    </Modal>

    <Modal idModal="UpdateCostCodeModal" :headerTitle="$t('Update Cost Code')">
        <div class="user-modal-form">
        <div class="form-group">
            <label>{{ $t('Cost Code') }}</label>
            <input type="text" class="form-control-plaintext" v-model="updateCostCode.costCode" :placeholder="$t('Cost Code Name')"/>
        </div>
        <div class="form-group" v-if="updateCostCode.isVariation==false">
            <label :class="{ 'required-style': !String(updateCostCode.name || '').trim() }">{{ $t('Description') }}</label>
            <textarea class="form-control" v-model="updateCostCode.name"></textarea>
            <span class="text-warning" v-if="!updateCostCode.name && isClickedUpdate">{{ $t('Required') }}</span>
        </div>
        <div class="form-group" v-if="updateCostCode.status==CostCodeStatusEnum.NOT_IN_USE">
            <label>{{ $t('Status') }}</label>
            <input type="text" class="form-control-plaintext" disabled :value="$t('NOT IN USE')">
        </div>
        <div class="form-group" v-else>
            <label :class="{ 'required-style': !updateCostCode.status }">{{ $t('Status') }}</label>
            <select class="form-select" v-model="updateCostCode.status">
                <option :value="key + 1" v-for="(item, key) in CostCodeStatus" :key="key">{{ $t(item) }}</option>
            </select>
            <span class="text-warning" v-if="!updateCostCode.status && isClickedUpdate">{{ $t('Required') }}</span>
        </div>
        <div class="form-group" v-if="updateCostCode.isItemCostCode" >
            <label :class="{ 'required-style': !updateCostCode.type }">{{ $t('Type') }}</label>
            <select class="form-select" v-model="updateCostCode.type">
                <option :value="key + 1" v-for="(item,key) in CostCodeTypeNames" :key="key">{{ $t(item) }}</option>
            </select>
            <small class="text-warning" v-if="!updateCostCode.type&&isClickedUpdate">{{ $t('Required') }}</small>
        </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeUpdateModal" class="btn user-modal-btn user-modal-btn--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <button class="btn user-modal-btn user-modal-btn--submit" ref="createBtn" @click="UpdateCostCodeRun">{{ $t('Save Changes') }}</button>
        </template>
    </Modal>

</template>


<script src="@/assets/directoryJs/CostCode.js" />
